import { MUTATIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const SORT_WIRES = createWires({
  setSort: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.search.setSort),
  toggleSortList: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.core.toggleOpenSortList),
  collapseSort: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.core.setOpenSortList, false)
});
